/**
 * INBOX STATE (INBOX.md §6) — the signed-in person's read / archive / delete state for Inbox items (own rows only).
 *   GET  /data-plane/me/inbox            → { states: [{key, read, readAt, archivedAt, deletedAt, purgedAt, snap}], retention }
 *   POST /data-plane/me/inbox {op, items} → { written }   op: read · unread · archive · unarchive · delete · restore · purge
 */
import { getRestApiBearerToken } from './apiToken';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.stepflow.dev';
export const MAX_ITEMS_PER_CALL = 100;

async function call(path, init = {}) {
  const token = getRestApiBearerToken();
  if (!token) throw new Error('Not authenticated');
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...init, headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...(init.headers || {}) } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || data.error || `HTTP ${res.status}`);
  return data;
}

export const getInboxState = () => call('/data-plane/me/inbox');

/** Apply ``op`` to ``items`` ([{key, snap?}]) — chunked to the server's per-call bound. */
export async function setInboxState(op, items) {
  let written = 0;
  for (let i = 0; i < (items || []).length; i += MAX_ITEMS_PER_CALL) {
    const r = await call('/data-plane/me/inbox', { method: 'POST',
      body: JSON.stringify({ op, items: items.slice(i, i + MAX_ITEMS_PER_CALL) }) });
    written += (r && r.written) || 0;
  }
  return { written };
}
